import type { ActivationSetSchema } from "app/pages/activation/types/api";

export enum ProjectsFilters {
    All = "all",
    My = "my",
    Inc = "inc",
    Dec = "dec",
    NewAlert = "newAlert",
}

export type FiltersData = Record<ProjectsFilters, ActivationSetSchema[]>;

export type FiltersFlags = Record<ProjectsFilters, boolean>;
